import {
  BookOpen,
  FileCode,
  Files,
  FileText,
  Handshake,
  HelpCircle,
  Home,
  Mail,
  MessageSquare,
  RefreshCcw,
  ScrollText,
  Settings,
  ShieldUser,
  UserCheck,
  Users,
} from 'lucide-react';
import type { NavigationGroup, StandaloneNavigationItem } from './types';

export const AVATAR_MAX_INITIALS = 2;

export const STANDALONE_NAVIGATION_ITEMS: StandaloneNavigationItem[] = [
  {
    name: 'navigation.items.home',
    path: '/home',
    icon: Home,
    requiredPermission: null, // Accessible to all authenticated users
  },
];

export const NAVIGATION_GROUPS: NavigationGroup[] = [
  {
    label: 'navigation.groups.customers',
    icon: UserCheck,
    defaultOpen: true,
    items: [
      {
        name: 'navigation.items.communication',
        path: '/communication',
        icon: MessageSquare,
        requiredPermission: { entity: 'communication', action: 'read' },
      },
      {
        name: 'navigation.items.customerControl',
        path: '/customers/control',
        icon: RefreshCcw,
        requiredPermission: {
          entity: 'control',
          action: 'read',
        },
      },
    ],
  },
  {
    label: 'navigation.groups.compliance',
    icon: Handshake,
    defaultOpen: true,
    items: [
      {
        name: 'navigation.items.kyc',
        path: '/kyc',
        icon: FileText,
        requiredPermission: { entity: 'kyc', action: 'read' },
      },
    ],
  },
  {
    label: 'navigation.groups.settings',
    icon: Settings,
    items: [
      {
        name: 'navigation.items.users',
        path: '/users',
        icon: Users,
        requiredPermission: { entity: 'users', action: 'read' },
      },
      {
        name: 'navigation.items.roles',
        path: '/roles',
        icon: ShieldUser,
        requiredPermission: { entity: 'roles', action: 'read' },
      },
      {
        name: 'navigation.items.kycPdfTexts',
        path: '/kyc-pdf-texts',
        icon: FileText,
        requiredPermission: { entity: 'kyc-pdf-texts', action: 'read' },
      },
      {
        name: 'navigation.items.emailTemplates',
        path: '/email-templates',
        icon: Mail,
        requiredPermission: { entity: 'email-templates', action: 'read' },
      },
      {
        name: 'navigation.items.documentTypes',
        path: '/document-types',
        icon: Files,
        requiredPermission: { entity: 'document-groups', action: 'read' },
      },
      {
        name: 'navigation.items.logs',
        path: '/logs',
        icon: ScrollText,
        requiredPermission: { entity: 'logs', action: 'read' },
      },
      {
        name: 'navigation.items.xmlLogs',
        path: '/xml-logs',
        icon: FileCode,
        requiredPermission: { entity: 'logs', action: 'xmls' },
      },
    ],
  },
];

export const BOTTOM_NAVIGATION_ITEMS = [
  {
    name: 'navigation.items.help',
    url: '/help/',
    external: true,
    icon: BookOpen,
    ariaLabel: 'navigation.ariaLabels.help',
  },
  {
    name: 'navigation.items.support',
    url: 'https://chloomis.atlassian.net/servicedesk/customer/portal/1/group/20/create/5',
    external: true,
    icon: HelpCircle,
    ariaLabel: 'navigation.ariaLabels.support',
  },
  {
    name: 'navigation.items.feedback',
    url: 'https://chloomis.atlassian.net/servicedesk/customer/portal/108/group/123/create/1108',
    external: true,
    icon: MessageSquare,
    ariaLabel: 'navigation.ariaLabels.feedback',
  },
];
